import { Injectable } from "@angular/core";
import { Adapter } from "./adapter";
import { Category } from "./category.model";
import { ChoiceMinimal } from "./choice.model";
import { Message } from "./message.model";
import { Response } from "./response.model";

export class Alert {

    public pin: google.maps.Marker;
    public pinLogo: google.maps.Marker;
    public circle: google.maps.Circle;
    public isLoading: boolean = false;
    public statusUpdatedByOperator: boolean = false;

    constructor(
        public uid: string,
        public model_uid: string,
        public organization_uid: string,
        public version: number,
        public title: string,
        public status: string,
        public created_at: Date,
        public creator_name: string,
        public creator_uid: string,
        public creator_phone: string,
        public icon: string,
        public fa_icon: string,
        public fa_color: string,
        public lat: number,
        public lng: number,
        public accuracy: number,
        public category: Category,
        public responses: Response[] = [],
        public messages: Message[] = [],
        public isShared: boolean,
        public address: string,
        public locality: string,
        public isTest: boolean,
        public isPublic: boolean,
        public isHandlingAnonymized: boolean,
        public sentToActionPlan: boolean,
        public allowIntervention?: boolean,
        public operator_name?: string,
        public sound?: string
      ) { }
}

@Injectable({
  providedIn: "root",
})
export class AlertAdapter implements Adapter<Alert> {

  adapt(item: any): Alert {

    let responses: Response[] = [];
    (item.responses as []).forEach((r: Response) => {
      let response = r.response;
      if (r.type === "SIMPLE_CHOICE") {
        let choices = [];
        if ((response as []).length > 0) {
          choices.push(new ChoiceMinimal(response[0].uid, response[0].response));
        }
        response = choices;
      } else if (r.type === 'MULTI_CHOICE') {
        let choices = [];
        (response as []).forEach((rsp: any) => {
          choices.push(new ChoiceMinimal(rsp.uid, rsp.response))
        });
        response = choices;
      }
      
      responses.push(new Response(
        r.uid,
        r.question,
        r.question_uid,
        response,
        r.icon,
        r.type
      ))
    });

    let messages: Message[] = [];
    (item.messages as [])?.forEach((m: Message) => {
      messages.push(
        new Message(
          m.uid,
          m.message,
          m.from,
          m.from_uid,
          new Date(m.date),
          m.seen,
          m.order,
          m.from_avatar
        )
      )
    });

    return new Alert(
      item.uid, 
      item.model_uid, 
      item.organization_uid,
      item.version,
      item.title, 
      item.status, 
      new Date(item.created_at), 
      item.creator_name, 
      item.creator_uid,
      item.creator_phone,
      item.icon, 
      item.fa_icon, 
      item.fa_color, 
      item.lat, 
      item.lng,
      item.accuracy ? item.accuracy : null,
      item.category, 
      item.responses, 
      messages, 
      item.is_shared, 
      item.address,
      item.locality,
      item.is_test,
      item.public,
      item.anonymize_handling,
      item.sent_to_action_plan,
      item.allow_intervention,
      item.operator_name ? item.operator_name : undefined,
      item.sound ? item.sound : null
    );
  }
}
